var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TableSimpleBlock',{attrs:{"title":"Resumen instalaciones por proveedor","items":_vm.officeInstallationReportData,"fields":_vm.fields,"isLoading":_vm.isOfficeInstallationReportLoading}})}
var staticRenderFns = []

export { render, staticRenderFns }